import { useEffect } from 'react';

import useQuickActions from '@hooks/useQuickActions';
import palette from '@lib/core/src/theme/palette';
import { styled, Stack, Typography } from '@mui/material';

const borderGradient = `linear-gradient(90deg, ${palette.blue[400]} 0%, ${palette.purple[100]} 36%, ${palette.purple[300]} 67%, ${palette.purple[400]} 100%)`;

const RemainingQuickActionsContainer = styled(Stack)({
  position: 'absolute',
  bottom: 0,
  right: '50%',
  transform: 'translate(50%, 50%)',
  zIndex: 1001,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  padding: '2px 8px',
  background: `linear-gradient(${palette.white}, ${palette.white}) padding-box, ${borderGradient} border-box`,
  border: '1px solid transparent',
  borderRadius: '6px',
  boxSizing: 'border-box'
});

const RemainingQuickActionsNumber = styled(Typography)({
  color: palette.purple[300],
  fontFamily: 'Reddit Sans',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '16px',
  textAlign: 'center'
});

const RemainingQuickActionsLabel = styled(Typography)({
  color: palette.purple[300],
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '16px',
  textAlign: 'center'
});

type RemainingQuickActionsProps = {
  firstQuickActionId: string;
};

const RemainingQuickActions = ({ firstQuickActionId }: RemainingQuickActionsProps) => {
  const { quickActions, refetchQuickActions } = useQuickActions({ count: -1 });

  useEffect(() => {
    refetchQuickActions();
  }, [refetchQuickActions, firstQuickActionId]);

  return (
    <RemainingQuickActionsContainer>
      <RemainingQuickActionsNumber>{quickActions.length}</RemainingQuickActionsNumber>
      <RemainingQuickActionsLabel>Left</RemainingQuickActionsLabel>
    </RemainingQuickActionsContainer>
  );
};

export default RemainingQuickActions;
